import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { sort } from '../../util'
import { Col, Grid, Row } from 'react-bootstrap'
import ActivityTable from '../../ActivityTable/ActivityTable'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'

const ActivitySection = ({
  match,
  filterActivitiesByStatus,
  activitiesSortBy,
  missions,
  isLoadedMissions,
  baView,
}) => {
  const history = useHistory()

  const ambassadorDataMapper = ambassadorData => {
    const data = ambassadorData.map(mission => {
      let campaignMetrics = []
      try {
        if (
          mission.campaign &&
          mission.campaign.metrics &&
          mission.campaign.metrics.nodes &&
          mission.campaign.metrics.nodes.length
        ) {
          campaignMetrics = mission.campaign.metrics.nodes.map(metric => ({
            ...metric,
            name: metric.label || metric.name,
          }))
        }
      } catch (error) {
        campaignMetrics = mission.campaign.metrics.nodes
        console.warn(`Can't load proper metric names`)
      }
      const conversions = baView
        ? mission.conversions.nodes.filter(
            ({ bonusDisqualified, inRedemption }) =>
              !bonusDisqualified && inRedemption,
          )
        : mission.conversions.nodes

      return {
        ...mission,
        timeStart: mission.timeRangeStart,
        checkout: { flyerQuantity: mission.totalFlyersDistributed },
        conversions: conversions || [],
        campaignMetrics,
        isSpied:
          mission.spyInformation &&
          mission.spyInformation.spyDetails &&
          mission.spyInformation.spyDetails.checkInTime,
        isBaView: baView,
      }
    })

    return data
  }

  let ambassadorActivities = useMemo(() => ambassadorDataMapper(missions), [
    missions,
    baView,
  ])
  ambassadorActivities = filterActivitiesByStatus(ambassadorActivities)
  ambassadorActivities = sort({
    data: ambassadorActivities,
    sortBy: activitiesSortBy,
  })

  return (
    <AmbassadorSection className="no-padding overflow-auto">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Activity</SectionTitle>
          </Col>
        </Row>
        {missions.length ? (
          <Row>
            <Col xs={12} className="full-width-table">
              <ActivityTable
                history={history}
                match={match}
                ambassadorActivities={ambassadorActivities}
                baView={baView}
              />
            </Col>
          </Row>
        ) : isLoadedMissions ? (
          <p className="not-found" cypress_id={'noActivities'}>
            No activities found
          </p>
        ) : (
          <p className="not-found" cypress_id={'loading'}>
            Loading...
          </p>
        )}
      </Grid>
    </AmbassadorSection>
  )
}

export default ActivitySection
